import { render, staticRenderFns } from "./AlterTeacher.vue?vue&type=template&id=1c19b9c0&scoped=true&"
import script from "./AlterTeacher.vue?vue&type=script&lang=js&"
export * from "./AlterTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AlterTeacher.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AlterTeacher.vue?vue&type=style&index=1&id=1c19b9c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c19b9c0",
  null
  
)

export default component.exports